<template lang="html">
  <div v-if="onboardingComplete" class="navBG" :class="{dark: darkmode}">
    <div class="nav">
      <div class="navWrapper">
        <div class="iconWrapper" @click="navigateStatistics">
          <AveIcon icon="statistics" icon-type="normal" :class="{dark: darkmode}" />
          <svg class="activeSign" v-if="active === 'statistics'" width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="3" cy="3" r="3" fill="#00FF96"/>
          </svg>
        </div>
        <div class="iconWrapper" @click="navigateProjects">
          <AveIcon icon="projects" icon-type="normal" :class="{dark: darkmode}" />
          <svg class="activeSign" v-if="active === 'projects'" width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="3" cy="3" r="3" fill="#00FF96"/>
          </svg>
        </div>
        <div class="iconWrapper" @click="navigateConfig">
          <AveIcon icon="config" icon-type="normal" :class="{dark: darkmode}" />
          <svg class="activeSign" v-if="active === 'config'" width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="3" cy="3" r="3" fill="#00FF96"/>
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AveIcon from '@/components/AveIcon.vue';

export default {
  components: {
    AveIcon,
  },
  computed: {
    onboardingComplete() {
      return this.$store.state.onboardingComplete;
    },
  },
  data() {
    return {
      active: 'projects',
    };
  },
  methods: {
    navigateStatistics() {
      if (this.$route.name === 'Statistics') return;
      this.$router.push({ name: 'Statistics' });
      this.active = 'statistics';
    },
    navigateProjects() {
      if (this.$route.name === 'Projects') return;
      this.$router.push({ name: 'Projects' });
      this.active = 'projects';
    },
    navigateConfig() {
      if (this.$route.name === 'Config') return;
      this.$router.push({ name: 'Config' });
      this.active = 'config';
    },
  },
  props: {
    darkmode: Boolean,
  },

};
</script>

<style lang="stylus" scoped>
@require '../assets/styles/colors.styl'
@require '../assets/styles/styles.styl'

.navBG
  width 100%
  height 62px
  background-color: $white
  &.dark
    background-color $normal
    .nav
      background-color $normal
      border-color $darkmodeWhite
      box-shadow $darkmodeShadow
      color $darkmodeWhite

.nav
  width $navWidth
  height $navHeight
  margin auto
  margin-top 0
  background-color $white
  border $borderBoxes
  border-color $normal
  box-shadow $shadow
  border-radius $radiusBoxes

.navWrapper
  width $navWrapperWidth
  margin auto
  display flex
  align-items center
  flex-direction row
  justify-content space-between

.iconWrapper
  height $navHeight
  display flex
  flex-direction column
  align-items center
  padding-top 10px

.iconWrapper:hover
  cursor pointer

.activeSign
  margin-top 2px

</style>
